import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Text, themeVars } from '@eds-web/react';

import { selectAccountId } from '../../selectors/account.selector';
import {
    StyledCompetitiveHeader,
    CompetitiveContent,
    StyledCompetitiveAccount
} from './CompetitiveView.style';
import { CompetitiveTabs } from './CompetitiveTabs';
import { NotificationAlert } from './NotificationAlert';
import { useCompetitive } from '../../hooks/useCompetitive';
import { TabProvider } from '../../contexts/TabContext';
import { PrizeExpansionProvider } from '../../contexts/PrizeExpansionContext';

interface CompetitiveHeaderProps {
    supportUrl: string;
    supportSiteName: string;
}

const CompetitiveHeader: React.FC<CompetitiveHeaderProps> = ({ supportUrl, supportSiteName }) => {
    const { t } = useTranslation();

    return (
        <StyledCompetitiveHeader>
            <Text variant="heading2XL">{t('epic.esport.prizes.header.title')}</Text>
            <Text
                dangerouslySetInnerHTML={{
                    __html: t('epic.esport.prizes.header.content.v2', {
                        supportUrl,
                        supportSiteName
                    })
                }}
                style={{ color: themeVars.color.transparent.light['065'] }}
                variant="paragraphMD"
            />
        </StyledCompetitiveHeader>
    );
};

export const CompetitiveView: React.FC = () => {
    const { t } = useTranslation();
    const accountId = useSelector(selectAccountId);
    useCompetitive();

    const supportConfig = useMemo(
        () => ({
            supportSiteName: t('epic.common.support_site'),
            supportUrl: window.__epic_client_state.config.supportUrl
        }),
        [t]
    );

    return (
        <TabProvider>
            <PrizeExpansionProvider>
                <CompetitiveContent>
                    <NotificationAlert />
                    <CompetitiveHeader
                        supportUrl={supportConfig.supportUrl}
                        supportSiteName={supportConfig.supportSiteName}
                    />
                    <StyledCompetitiveAccount
                        variant={'paragraphMD'}
                        dangerouslySetInnerHTML={{
                            __html: t('epic.esport.prizes.header.id', {
                                accountId
                            })
                        }}
                    />
                    <CompetitiveTabs />
                </CompetitiveContent>
            </PrizeExpansionProvider>
        </TabProvider>
    );
};
